// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_61-2";
export var blackBorderOnHover = "_61-7";
export var cell = "_61-6";
export var cellContainer = "_61-3";
export var checked = "_61-8";
export var disabled = "_61-5";
export var featuredIconCellContainer = "_61-9";
export var featuredIconTextContainer = "_61-b";
export var featuredIconWrapper = "_61-a";
export var noBorder = "_61-c";
export var orangeSelectedRow = "_ez-3";
export var overflowableText = "_61-0";
export var overflowableTextContainer = "_61-1";
export var row = "_68-0";
export var rowCheckboxCell = "_61-4";
export var selectableTable = "_ez-2";